import React, {useCallback} from 'react'
import Avatar from "react-avatar";
import {FormattedDate, FormattedMessage, FormattedRelativeTime} from "react-intl";
import Stepper from "react-stepper-horizontal";
import {
    faChevronDown,
    faFileDownload,
    faFilePdf,
    faPencil,
    faCheck,
    faSignOutAlt,
    faStickyNote,
    faCopy
} from "@fortawesome/pro-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { Scrollbars } from 'react-custom-scrollbars';
import TipBox from "./tipBox";
import Actions from "../helpers/actions";


var fileBaseURL = ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development')?"https://doganyildiz.omgdemo.site":"https://doganyildiz.omgdemo.site");

export default class ProjectItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data:this.props.data,
            dropDownOpen:false
        };
    }
    componentDidMount(){

    }

    componentWillReceiveProps(nextProps){
        this.setState({data:nextProps.data});
    }
    renderOfferCreationDate(){
        if(typeof this.state.data.statusMap.InitialOffer != "undefined"){
            return(
                <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                    return(
                        <small>Created <FormattedRelativeTime value={((new Date(this.state.data.statusMap.InitialOffer[0].creationDate).getTime() - new Date().getTime()) / 1000)} numeric="auto" updateIntervalInSeconds={10} /></small>
                    )
                }} content={()=>{
                    return(
                        <div style={{color:"#FFF",fontSize:14}}>
                            {new Date(this.state.data.statusMap.InitialOffer[0].creationDate).toDateString()}
                        </div>
                    )
                }}/>
            );
        }
    }
    render(){
        var currentlyStep = 0;
        switch(this.state.data.lastStatus){
            case "InitialOffer":
                currentlyStep = 0;
                break;
            case "Order":
                currentlyStep = 1;
                break;
            case "WorkOrder":
                currentlyStep = 2;
                break;
            case "WorkOrderwData":
                currentlyStep = 2;
                break;
            case "OrderApproved":
                currentlyStep = 2;
                break;
        }

        return(
            <li className={"user item"+(this.state.dropDownOpen?" open":"")}>
                <div className={"main row align-middle"}>
                    <div className={"columns name shrink"}>
                        <div className={"title"}>
                            <div className={"row collapse"}>
                                <div className={"columns"}>
                                    <a><b>{this.state.data.customer.name}</b></a>
                                    <small>{this.state.data.dyNumber}</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"columns name projectName shrink"}>
                        <div className={"title"}>
                            <a><b>{this.state.data.name}</b></a>
                            {this.renderOfferCreationDate()}
                        </div>
                    </div>
                    <div className={"columns small-3 name stepper noPaddingRight"}>
                        <Stepper titleTop={4} circleTop={0} size={22} circleFontSize={12} defaultBorderStyle={{lineHeight:0}} steps={
                            [{
                                title:"Teklif",
                                onClick: (e) => {
                                    window.open(fileBaseURL+"/tr/api/files/offer/"+this.state.data.statusMap.InitialOffer[0].formId,"_blank");
                                    e.preventDefault()
                                }
                            }, {
                                title:"Sipariş",
                                onClick: (e) => {
                                    window.open(fileBaseURL+"/tr/api/files/order/"+this.state.data.projectStatus[1].id,"_blank");
                                    e.preventDefault()
                                }
                            },{
                                title:"İş Emri",
                                onClick: (e) => {
                                    window.open(fileBaseURL+"/tr/api/files/workOrder/"+this.state.data.id,"_blank");
                                    e.preventDefault()
                                }
                            }, {
                                title:"Üretim"
                            }, {
                                title:"Sevkiyat"
                            }]
                        } titleFontSize={12} defaultTitleColor={"#666"} activeTitleColor={"#4085c7"} completeTitleColor={"#4085c7"} activeBorderColor={"#666"} defaultBarColor={"#CCC"}
                                 activeStep={currentlyStep} />
                    </div>
                    <div className={"columns"}>
                        <div className="actions">
                            <div className="row collapse align-right">
                                <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                    return(
                                        <a className="action columns shrink button"
                                           style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                           onClick={()=>{
                                               //this.props.openPopUp("notes",2);
                                               Actions.emit("openPopUp",{target:"notes",data:this.state.data})
                                           }}
                                        >
                                            <FontAwesomeIcon icon={faStickyNote} size="lg"/>
                                        </a>
                                    )
                                }} content={()=>{
                                    return(
                                        <p className={"tipBoxWrapper small"}>
                                            <FormattedMessage
                                                id="actionButton.notes"
                                            />
                                        </p>
                                    )
                                }}/>
                                {this.renderStatusActions(this.state.data)}
                            </div>
                        </div>
                    </div>
                    <div className={"columns shrink"}>
                        <div className={"arrow"} onClick={()=>{
                            this.setState({dropDownOpen:!this.state.dropDownOpen});
                        }}>
                            <FontAwesomeIcon icon={faChevronDown} size="x1"/>
                        </div>
                    </div>
                </div>
                {this.renderDropDown()}
            </li>
        );
    }
    renderStatusActions(data){
        switch(data.lastStatus){
            case "InitialOffer":
                if(Actions.hasAccess(3)){
                    return(
                        <div>
                            <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                return(
                                    <a className="action columns shrink button yellow"
                                       style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                       onClick={()=>{
                                           this.props.reviseOffer({id:data.id,fid:data.statusMap.InitialOffer[0].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                                           //this.state.data.statusMap.InitialOffer[0].formId
                                       }}
                                    >
                                        <FontAwesomeIcon icon={faPencil} size="lg"/>
                                    </a>
                                )
                            }} content={()=>{
                                return(
                                    <p className={"tipBoxWrapper small"}>
                                        <FormattedMessage
                                            id="actionButton.revise"
                                        />
                                    </p>
                                )
                            }}/>
                            <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                return(
                                    <a className="action columns shrink button green"
                                       style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                       onClick={()=>{
                                           this.props.convertOrder(data.id, data.responsible.id);
                                       }}
                                    >
                                        <FontAwesomeIcon icon={faCheck} size="lg"/>
                                    </a>
                                )
                            }} content={()=>{
                                return(
                                    <p className={"tipBoxWrapper small"}>
                                        <FormattedMessage
                                            id="actionButton.approve"
                                        />
                                    </p>
                                )
                            }}/>
                        </div>
                    );
                }
                break;
            case "Order":
                return(
                    <div>
                        <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                            return(
                                <a key={"revise"+data.statusMap.InitialOffer[0].formId} className="action columns shrink button"
                                   style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                   onClick={()=>{
                                       this.props.revisePapers({id:data.id,fid:data.statusMap.InitialOffer[0].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                                   }}
                                >
                                    <FontAwesomeIcon icon={faCopy} size="lg"/>
                                </a>
                            )
                        }} content={()=>{
                            return(
                                <p className={"tipBoxWrapper small"}>
                                    <FormattedMessage
                                        id="actionButton.revisePapers"
                                    />
                                </p>
                            )
                        }}/>
                        <a className="action columns shrink button"
                           style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                           onClick={()=>{
                               this.props.openOrderForm({tid:data.templateId,projectName:data.projectName,dyNumber:data.dyNumber,pid:data.projectStatus[1].formId});
                           }}
                        >
                            Manage
                        </a>
                    </div>
                );
                break;
            case "OrderApproved":
                if(Actions.hasAccess(5)){
                    return(
                        <div>
                            <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                return(
                                    <a className="action columns shrink button"
                                       style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                       onClick={()=>{
                                           this.props.revisePapers({id:data.id,fid:data.statusMap.InitialOffer[0].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                                       }}
                                    >
                                        <FontAwesomeIcon icon={faCopy} size="lg"/>
                                    </a>
                                )
                            }} content={()=>{
                                return(
                                    <p className={"tipBoxWrapper small"}>
                                        <FormattedMessage
                                            id="actionButton.revisePapers"
                                        />
                                    </p>
                                )
                            }}/>
                            <a className="action columns shrink button green"
                               style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                               onClick={()=>{
                                   this.props.convertWorkOrder(data.projectStatus[1].formId);
                               }}
                            >
                                Approve
                            </a>
                        </div>
                    );
                }
                break;
            case "WorkOrder":
                if(Actions.hasAccess(5)){
                    return(
                        <div>
                            <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                                return(
                                    <a className="action columns shrink button"
                                       style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                       onClick={()=>{
                                           this.props.revisePapers({id:data.id,fid:data.statusMap.InitialOffer[0].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                                       }}
                                    >
                                        <FontAwesomeIcon icon={faCopy} size="lg"/>
                                    </a>
                                )
                            }} content={()=>{
                                return(
                                    <p className={"tipBoxWrapper small"}>
                                        <FormattedMessage
                                            id="actionButton.revisePapers"
                                        />
                                    </p>
                                )
                            }}/>
                            <a className="action columns shrink button"
                               style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                               onClick={()=>{
                                   this.props.openWorkOrderForm({id:data.id,fid:data.projectStatus[3].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                               }}
                            >
                                Manage
                            </a>
                        </div>
                    );
                }
                break;
            case "WorkOrderwData":
                return(
                    <div>
                        <TipBox isOpen={this.state.toolTipOpen} attachment={"bottom center"} element={()=>{
                            return(
                                <a className="action columns shrink button"
                                   style={{marginRight:10,position:"relative",fontSize:15,paddingTop:7,paddingBottom:7}}
                                   onClick={()=>{
                                       this.props.revisePapers({id:data.id,fid:data.statusMap.InitialOffer[0].formId,projectName:data.projectName,dyNumber:data.dyNumber});
                                   }}
                                >
                                    <FontAwesomeIcon icon={faCopy} size="lg"/>
                                </a>
                            )
                        }} content={()=>{
                            return(
                                <p className={"tipBoxWrapper small"}>
                                    <FormattedMessage
                                        id="actionButton.revisePapers"
                                    />
                                </p>
                            )
                        }}/>
                    </div>
                );
                break;
            default:
                break;
        }
    }
    renderOfferRevisions(){
        if(typeof this.state.data.statusMap.InitialOffer != "undefined"){
            return this.state.data.statusMap.InitialOffer.map((item)=>{
                return(
                    <div className={"groupItem"} onClick={()=>{
                        window.open(fileBaseURL+"/tr/api/files/offer/"+item.formId+"/"+item.revNum,"_blank");
                    }}>
                        <div className={"row align-middle"}>
                            <div className={"columns"}>
                                <FormattedDate
                                    value={item.creationDate}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    hour="2-digit"
                                    minute="2-digit"
                                />
                            </div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                            </div>
                        </div>
                    </div>
                )
            });
        }
    }
    renderOrderRevisions(){
        if(typeof this.state.data.statusMap.Order != "undefined"){
            return this.state.data.statusMap.Order.map((item)=>{
                return(
                    <div className={"groupItem"} onClick={()=>{
                        window.open(fileBaseURL+"/tr/api/files/order/"+item.formId,"_blank");
                    }}>
                        <div className={"row align-middle"}>
                            <div className={"columns"}>
                                <FormattedDate
                                    value={item.creationDate}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    hour="2-digit"
                                    minute="2-digit"
                                /></div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                            </div>
                        </div>
                    </div>
                )
            });
        }
    }
    renderOrders(){
        if(typeof this.state.data.statusMap.WorkOrderwData != "undefined"){
            return this.state.data.statusMap.WorkOrderwData.map((item)=>{
                return(
                    <div className={"groupItem"} onClick={()=>{
                        window.open(fileBaseURL+"/tr/api/files/workOrder/"+item.formId,"_blank");
                    }}>
                        <div className={"row align-middle"}>
                            <div className={"columns"}>
                                <FormattedDate
                                    value={item.creationDate}
                                    year="numeric"
                                    month="long"
                                    day="2-digit"
                                    hour="2-digit"
                                    minute="2-digit"
                                /></div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                            </div>
                        </div>
                    </div>
                )
            });
        }
    }
    renderDropDown(){
        if(this.state.dropDownOpen){
            return(
                <div className={"dropDown"}>
                    <div className={"row"}>
                        <div className={"columns small-3"}>
                            <div className={"groupName"}>Offers</div>
                            <Scrollbars
                                style={{ height: 132 }}>
                                {this.renderOfferRevisions()}
                            </Scrollbars>
                        </div>
                        <div className={"columns small-3"} style={{borderLeftStyle:"solid",borderLeftWidth:1,borderLeftColor:"#EEE"}}>
                            <div className={"groupName"}>Orders</div>
                            <Scrollbars
                                style={{ height: 132 }}>
                                {this.renderOrderRevisions()}
                            </Scrollbars>
                        </div>
                        <div className={"columns small-3"} style={{borderLeftStyle:"solid",borderLeftWidth:1,borderLeftColor:"#EEE"}}>
                            <div className={"groupName"}>Work Orders</div>
                            <Scrollbars
                                style={{ height: 132 }}>
                                {this.renderOrders()}
                            </Scrollbars>
                        </div>
                        <div className={"columns small-3"} style={{borderLeftStyle:"solid",borderLeftWidth:1,borderLeftColor:"#CCC"}}>
                            <div className={"groupName"}>Documents</div>
                            <Scrollbars
                                style={{ height: 132 }}>
                                {this.renderPaperItem("commercialOffer")}
                                {this.renderPaperItem("proformaInvoice")}
                                {this.renderPaperItem("packingList")}

                            </Scrollbars>
                        </div>
                    </div>
                </div>
            );
        }
    }
    renderPaperItem(paperType){
        switch(paperType){
            case "commercialOffer":
                return(
                    <div className={"groupItem"} onClick={()=>{
                        window.open(fileBaseURL+"/tr/api/files/commercialOffer/"+this.state.data.statusMap.InitialOffer[0].formId,"_blank");
                    }}>
                        <div className={"row align-middle"}>
                            <div className={"columns"}>
                                Commercial Offer
                            </div>
                            <div className={"columns shrink"}>
                                <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                            </div>
                        </div>
                    </div>
                );
                break;
            case "proformaInvoice":
                if(this.state.data.lastStatus != "InitialOffer"){
                    return(
                        <div className={"groupItem"} onClick={()=>{
                            window.open(fileBaseURL+"/tr/api/files/invoice/"+this.state.data.statusMap.InitialOffer[0].formId,"_blank");
                        }}>
                            <div className={"row align-middle"}>
                                <div className={"columns"}>
                                    Proforma Invoice
                                </div>
                                <div className={"columns shrink"}>
                                    <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                                </div>
                            </div>
                        </div>
                    );
                }
                break;
            case "packingList":
                if(this.state.data.lastStatus != "InitialOffer"){
                    return(
                        <div className={"groupItem"} onClick={()=>{
                            window.open(fileBaseURL+"/tr/api/files/packageList/"+this.state.data.statusMap.InitialOffer[0].formId,"_blank");
                        }}>
                            <div className={"row align-middle"}>
                                <div className={"columns"}>
                                    Package List
                                </div>
                                <div className={"columns shrink"}>
                                    <FontAwesomeIcon icon={faFileDownload} size="lg"/>
                                </div>
                            </div>
                        </div>
                    );
                }
                break;
        }
    }
}

